import React, { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import './ErrorMsg.css';
const TContainer = ({ toastList }) => {
  
  // style={{ display: 'absolute', bottom: '150px' }}
  return (
    <div className='toastSet'>
      <ToastContainer
        autoClose={2000}
        stacked={true}
        newestOnTop={false}
        className={"toastStack"}
      />
    </div>
  );
};

export default TContainer;
